import React from 'react'
import { useTranslation } from 'react-i18next'
import { useChineseLang } from '../../i18n/chinese'
import { formatCorrectionDate } from './correctionDates'
import { CORRECTION_TURNAROUND_HOURS, PendingCorrection, isCorrectionOverdue } from 'utils/correctionsState'

interface Props {
  correction: PendingCorrection
}

/**
 * A submission the teacher has not closed yet, sitting above the finished
 * corrections. A returning learner who submits and comes straight back would
 * otherwise see only their OLD corrections and conclude today's went nowhere:
 * the same confusion as the empty page, just harder to spot.
 *
 * The same row as a finished correction, minus the chevron — there is nothing
 * to open yet. It shows the date, what was sent, and when to expect it.
 */
const PendingCorrectionCard: React.FC<Props> = ({ correction }) => {
  const { t } = useTranslation('corrections')
  const zhLang = useChineseLang()
  const overdue = isCorrectionOverdue(correction)

  return (
    <div className='correction-item'>
      <div className='w-row w-d-flex section-story-content mb-20'>
        <div className='w-col-12 w-col-medium-12 w-col-small-12 w-col-tiny-12 content-left box-padding border-full border-radius-10'>
          <div className='answer-box box-border'>
            <div className='correction-item-show cx-row cx-row--pending'>
              <span className='box-title'>
                <span>
                  {typeof correction.createdAt === 'number'
                    ? formatCorrectionDate(correction.createdAt)
                    : t('pending.submitted')}
                </span>
                {correction.answer && (
                  <span className='cx-row-preview' lang={zhLang}>
                    {correction.answer}
                  </span>
                )}
              </span>
              <span className='cx-row-end'>
                <span className='cx-row-meta cx-row-meta--waiting'>
                  {overdue
                    ? t('pending.overdue')
                    : t('pending.waiting', { hours: CORRECTION_TURNAROUND_HOURS })}
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PendingCorrectionCard
